import { render, staticRenderFns } from "./pay1.vue?vue&type=template&id=12296814&scoped=true"
import script from "./pay1.vue?vue&type=script&lang=js"
export * from "./pay1.vue?vue&type=script&lang=js"
import style0 from "./pay1.vue?vue&type=style&index=0&id=12296814&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12296814",
  null
  
)

export default component.exports